import React, { useContext, useEffect, useState } from "react";
import { TextField } from "@mui/material";
import { NavLink, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { AxiosError } from "axios";
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { server } from "../../../common";
import { useSelectAccess } from "../../../store/stateFunctions";
import configContext from "../../../context/configContext/configContext";

const initialValues = {
  email: "",
  fullname: "",
  feedback: "",
};

const StudentFeedback = () => {
  const user = useSelectAccess("Student");
  const [processing, setProcessing] = useState(false);
  const { setProgress } = useContext(configContext);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    values,
    handleBlur,
    touched,
    handleChange,
    handleSubmit,
    errors,
    resetForm,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Enter a valid email")
        .required("Please Enter Your Email"),
      fullname: Yup.string()
        .min(2, "Enter Full Name")
        .required("Please Full Name"),
      feedback: Yup.string()
        .min(2, "Enter Feedback")
        .required("Please Enter Your Feedback"),
    }),
    onSubmit: (values, action) => {
      setProcessing(true);
      setProgress(10);
      console.log(values);
      server
        .post("/feedbackform/addfeedback", values, {
          headers: {
            "Content-Type": "application/json",
            Authorization: user.authToken,
          },
        })
        .then(function (response) {
          console.log("api response", response.data);
          if (response.status === 200 || response.status === 201) {
            if (response.data) {
              toast.success("Submitted successfully");
              resetForm();
              setProgress(100);
            }
            setProcessing(false);
          }
        })
        .catch(function (error) {
          if (error.response?.data?.message)
            toast.error(error.response.data.message);
          else if (error.response?.data?.error) {
            toast.error(error.response.data.error);
          } else toast.error("Failed to connect to server");
          setProcessing(false);
          setProgress(100);
        });
    },
  });

  return (
    <>
      <section className="">
        <div className="container py-5 ">
          <div className="row d-flex justify-content-center align-items-center h-100">
            <div className="col col-xl-8">
              <div className="card" style={{ borderRadius: "1rem" }}>
                <div className="row g-0">
                  <div className=" ">
                    <div className="card-body p-4 text-black">
                      <form onSubmit={handleSubmit}>
                        <h5
                          className="fw-normal mb-3 pb-3"
                          style={{ letterSpacing: 1 }}
                        >
                          Share Feedback
                        </h5>
                        <div className="form-outline mb-2">
                          <TextField
                            name="fullname"
                            margin="dense"
                            type="text"
                            placeholder="Fullname"
                            variant="outlined"
                            label="Fullname"
                            value={values.fullname}
                            onChange={handleChange}
                            fullWidth
                            required
                          ></TextField>
                          {errors.fullname ? (
                            <p className="text-danger">{errors.fullname}</p>
                          ) : null}
                        </div>
                        <div className="form-outline mb-2">
                          <TextField
                            name="email"
                            margin="dense"
                            type="email"
                            placeholder="Email Id"
                            variant="outlined"
                            label="Email Id"
                            value={values.email}
                            onChange={handleChange}
                            fullWidth
                            required
                          ></TextField>
                          {errors.email ? (
                            <p className="text-danger">{errors.email}</p>
                          ) : null}
                        </div>
                        <div className="form-outline mb-2">
                          <TextField
                            name="feedback"
                            margin="dense"
                            type="text"
                            placeholder="Feedback"
                            variant="outlined"
                            label="Feedback"
                            value={values.feedback}
                            onChange={handleChange}
                            fullWidth
                            required
                          ></TextField>
                          {errors.feedback ? (
                            <p className="text-danger">{errors.feedback}</p>
                          ) : null}
                        </div>
                        <div className="text-center">
                          <button
                            type="submit"
                            className="banner text-white rounded-5 p-2 border-0 w-50"
                          >
                            Submit
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default StudentFeedback;
